import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {ProvidersCheckpointModelService} from '../../../Models/Tasks/Appccs/providers-checkpoint-model.service';
import {ProviderAppccStoreForm} from '../../../../Models/Tasks/Appccs/Checkpoints/provider-appcc-store.model';

@Injectable({
  providedIn: 'root'
})
export class ProvidersCheckpointApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: ProvidersCheckpointModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener los puntos de control de los proveedores
   *
   */
  getProvidersCheckpoints(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getAppccProveedores', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Guardar un proveedor
   *
   */
  saveProvider(form: ProviderAppccStoreForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setAppccProveedor', form).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Eliminar proveedor
   *
   */
  deleteProvider(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('deleteAppccProveedor', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Activar/Desactivar un proveedor
   *
   */
  toggleProvider(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('appccProveedorToggleActivo', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
